<div class="delivery-charges-modal">
  <div class="sec_head">
    <h2>{{ 'UserTopup' | translate }}</h2>
  </div>
  <div class="modal-body">
    <form
      class="attribute-modal"
      [formGroup]="userTopupForm"
      (ngSubmit)="onSubmit()">
      <div class="form_feilds gap_m">
        
          <div class="form_group w_100">
          <mat-label class="required">{{ 'Amount' | translate }}</mat-label>
          <mat-form-field appearance="fill">
            <input
              matInput
              type="number"
              formControlName="amount"
              placeholder="{{ 'Amount' | translate }}"
              class="form_control"
              min="0"
              step="0.01" />
          </mat-form-field>
          <mat-error
            *ngIf="
              submitted &&
              userTopupForm.controls['amount'].hasError('required')
            ">
            {{ 'Amount' | translate }}
            {{ 'IsRequired' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              submitted &&
              userTopupForm.controls['amount'].hasError('min')
            ">
            {{ 'Amount' | translate }}
            {{ 'MustBePositive' | translate }}
          </mat-error>
        </div>

      </div>
      <div class="submit_btn">
        <button type="submit" class="btnn btn_primary">
          {{ 'Submit' | translate }}
        </button>
      </div>
    </form>
  </div>
</div> 